export default "__VITE_ASSET__mkEJqMBw__"